import { render, staticRenderFns } from "./dp-detail-field.vue?vue&type=template&id=56925308&scoped=true"
import script from "./dp-detail-field.vue?vue&type=script&lang=js"
export * from "./dp-detail-field.vue?vue&type=script&lang=js"
import style0 from "./dp-detail-field.vue?vue&type=style&index=0&id=56925308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56925308",
  null
  
)

export default component.exports